import { Text } from '@simplywallst/ui-core';

import { formatterCurrency } from '@/utilities/format';

import { CurrencyISO } from '@/constants/currencies';

export const TotalValueDesktop = ({
  value,
  currencyISO,
}: {
  value: number;
  currencyISO: CurrencyISO;
}) => {
  if (value === 0) {
    return (
      <Text typography="smallStrong" color="whiteRGBA" opacity={0.3}>
        n/a
      </Text>
    );
  }
  return (
    <Text typography="baseStrong">{formatterCurrency(value, currencyISO)}</Text>
  );
};
